/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line import/no-cycle
import fetch from '../../../lib/fetch';
import * as types from '../types';
import { errCodeMap } from '../../../lib/errors';

const initRequestParam = () => ({
  contentId: '',
  mediaId: '',
  mediaType: '',
});

export default {
  namespaced: true,
  state: {
    mediaName: '',
    contentTitle: '',
    requestParam: {
      ...initRequestParam(),
    },
    pageInfo: {
      page: 1,
      count: 10,
      total: 0,
    },
    list: [],
    loading: false,
  },
  mutations: {
    [types.SET_PAGE_NUM](state, { pageNum }) {
      state.pageInfo.page = pageNum;
    },
    [types.SET_PAGE_COUNT](state, { pageCount }) {
      state.pageInfo.count = pageCount;
    },
    [types.SET_LIST](state, { total, list }) {
      state.list = list;
      state.pageInfo.total = total;
    },
    [types.SET_LIVE_ROOM](state, { mediaName, contentTitle, ...res }) {
      state.requestParam = {
        ...state.requestParam,
        ...res,
      };

      state.mediaName = mediaName;
      state.contentTitle = contentTitle || '';
    },
    _changeLoadingStatus(state, status) {
      state.loading = status;
    },
  },
  actions: {
    async [types.FETCH_LIST]({ commit, state }) {
      try {
        commit('_changeLoadingStatus', true);
        const data = {
          content_id: state.requestParam.contentId,
          media_type: state.requestParam.mediaType,
          media_id: state.requestParam.mediaId,
          start: (state.pageInfo.page - 1) * state.pageInfo.count,
          limit: state.pageInfo.count,
        };
        const res = await fetch.post('v1/cp/coupon/live_detail', data);
        if (res.code !== 0) {
          this._vm.$tip.error(errCodeMap[res.code] || '获取直播间优惠券失败');
          return;
        }

        commit(types.SET_LIST, res);
      } catch (e) {
        console.error(e);
        this._vm.$tip.error('获取直播间失败');
      } finally {
        commit('_changeLoadingStatus', false);
      }
    },
  },
  getters: {},
};
